import { APP_INITIALIZER, Provider } from '@angular/core';

function preventNumberInputScroll(): void {
  if (typeof document === 'undefined') {
    return;
  }

  document.addEventListener(
    'wheel',
    (event: WheelEvent) => {
      const target = event.target;
      if (target instanceof HTMLInputElement && target.type === 'number') {
        target.blur();
      }
    },
    { passive: true }
  );
}

export function providePreventNumberInputScroll(): Provider {
  return {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: () => () => preventNumberInputScroll(),
  };
}
